import { IPage } from 'store/donatePage/types';
import { TopIssueCard } from '../Cards/TopIssueCard';

export const TopIssues = ({ pages }: { pages: IPage[] }) => {
  return (
    <div className="top-issues-container">
      <div className="top-issues-row">
        {pages.map((issue, index) => (
          <div className="top-issue-container" key={index}>
            <TopIssueCard allowCardMaxWidth={false} issue={issue} />
          </div>
        ))}
      </div>
    </div>
  );
};
